import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { setErrorMessage } from '../../../../../shared/helpers/functionalities';
import { API_DESCUENTOS_MASIVOS } from '../../../../../shared/services/descuentosMasivos';
import { CircularProgress } from '@mui/material';

const EmailPruebaForm = ({ discount_id, handleCancel }) => {
    const [isLoading, setIsLoading] = useState(false);
    const {
        register,
        formState: { errors },
        handleSubmit,
    } = useForm({
        defaultValues: {
            nombre: '',
            email_to: '',
        },
    });

    const onSubmit = async (data) => {
        try {
            setIsLoading(true);
            const res = await API_DESCUENTOS_MASIVOS.sendEmailPrueba({
                ...data,
                discount_id,
            });
            if (res?.success) {
                toast.success('Email de prueba enviado.');
                handleCancel();
            }
        } catch (error) {
            toast.error(setErrorMessage(error));
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div className="descuentos-masivos-form">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group flex-grow-1">
                    <label htmlFor="nombre">Nombre</label>
                    <input
                        id="nombre"
                        type="text"
                        className="form-control"
                        {...register('nombre', {
                            required: 'El nombre es obligatorio',
                        })}
                    />

                    <div className="form-invalid">
                        {errors.nombre && errors.nombre.message}
                    </div>
                </div>
                <div className="form-group flex-grow-1">
                    <label htmlFor="email_to">Email</label>
                    <input
                        id="email_to"
                        type="email"
                        className="form-control"
                        {...register('email_to', {
                            required: 'El email es obligatorio',
                        })}
                    />

                    <div className="form-invalid">
                        {errors.email_to && errors.email_to.message}
                    </div>
                </div>
                <div className="d-flex align-items-center justify-content-end pt-2">
                    <button
                        type="button"
                        className="btn btn-default align-self-end"
                        onClick={handleCancel}
                    >
                        Cancelar
                    </button>
                    <button
                        type="submit"
                        className="btn btn-primary align-self-end ms-3"
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <CircularProgress color="inherit" size={22} />
                        ) : (
                            'Enviar'
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default EmailPruebaForm;
